export default __webpack_public_path__ + "static/media/Comp 2_00029.5d348a0c.png";